import {loadScript} from '../helpers';

const FACEBOOK = 'facebook';
const TWITTER = 'twitter';
const INSTAGRAM = 'instagram';
const TELEGRAM = 'telegram';
const RIDDLE = 'riddle';

const LIST_EMBEDS = [FACEBOOK, TWITTER, INSTAGRAM, TELEGRAM, RIDDLE];

const loadFbEmbed = ({$currentContentType, name, url}) => {
  if (window.FB) {
    window.FB.XFBML.parse($currentContentType);
  } else {
    loadScript(name, url, () => window.FB.XFBML.parse($currentContentType));
  }
};

const loadTwitterEmbed = ({$currentContentType, name, url}) => {
  if (window.twttr) {
    window.twttr.widgets.load($currentContentType);
  } else {
    loadScript(name, url, () => window.twttr.widgets.load($currentContentType));
  }
};

const loadInstagramEmbed = ({name, url}) => {
  if (window.instgrm) {
    window.instgrm.Embeds.process();
  } else {
    loadScript(name, url, window.instgrm?.Embeds?.process);
  }
};

const loadCustomEmbed = ({$currentContentType, name, url}) => {
  loadScript(`${name}-${$currentContentType?.dataset?.id}`, url);
};

const getEmbedData = type => {
  switch (type) {
    case FACEBOOK:
      return {className: '.fb-embed', callback: loadFbEmbed};
    case TWITTER:
      return {className: '.twitter-embed', callback: loadTwitterEmbed};
    case INSTAGRAM:
      return {className: '.instagram-embed', callback: loadInstagramEmbed};
    case TELEGRAM:
      return {className: '.telegram-embed', callback: loadCustomEmbed};
    case RIDDLE:
      return {className: '.riddle-embed', callback: loadCustomEmbed};
    default:
      return {};
  }
};

export const loadEmbeds = $currentContentType => {
  LIST_EMBEDS.forEach(embedItem => {
    const {className, callback} = getEmbedData(embedItem);
    const $embed = $currentContentType?.querySelector(className);

    if ($embed) {
      const url = $embed.getAttribute('src') || $embed.getAttribute('data-script');

      if (!url) {
        return null;
      }

      callback({$currentContentType, name: `${embedItem}-embed-script`, url});
    }
  });
};

